<script setup lang="ts">
// Login da área do afiliado. SSR normal; quem já tem a sessão da área vai ao
// painel (middleware afiliado-convidado). `?recuperar-senha=1` (link dos emails)
// abre o "Esqueci minha senha" sozinho.
import AfiliadoLogin from "@/components/AreaAfiliado/AfiliadoLogin.vue";
import ModalMessages from "@/components/Modais/ModalMessages.vue";
import ModalForgotPassword from "@/components/Modais/ModalForgotPassword.vue";

definePageMeta({
  middleware: ["not-found-lang", "afiliado-convidado"],
});

useNoIndex();

const route = useRoute();
const canonical = useCanonicalUrl();
const { idioma, t } = useAreaAfiliadoTextos();

useHead({
  templateParams: {
    subTitle: null,
    subPage: t.value.seo.titulo,
    page_url: canonical,
    page_description: t.value.seo.descricao,
    page_image: shareImage(),
    page_keywords: "bella da semana, programa de afiliados, área do afiliado",
    page_locale: idioma.value,
    page_url_pt: "https://belladasemana.com.br/pt-br/afiliado",
    page_url_en: "https://belladasemana.com.br/en/afiliado",
    page_canonical: canonical,
  },
});

const opcoesModal = ref({
  showModal: false,
  titleModal: "",
  textBodyModal: "",
  textButtonModal: "",
});
const mostrarEsqueci = ref(false);
const emailEsqueci = ref("");

function showModalMessages({ message }: { message: { show: boolean; title?: string; textBoby?: string; textButton?: string } }) {
  opcoesModal.value.showModal = message.show;
  opcoesModal.value.titleModal = message.title ?? "";
  opcoesModal.value.textBodyModal = message.textBoby ?? "";
  opcoesModal.value.textButtonModal = message.textButton ?? "";
}

function mensagem(texto: string) {
  showModalMessages({ message: { show: true, textBoby: texto, textButton: t.value.mensagens.fechar } });
}

function abrirEsqueci(email: string) {
  emailEsqueci.value = email;
  mostrarEsqueci.value = true;
}

onMounted(() => {
  const store = afiliadoStore();

  // Primeira carga com a sessão da área (o middleware não redireciona durante a
  // hidratação).
  if (store.token && !route.query["recuperar-senha"]) {
    navigateTo({ name: "language-afiliado-painel", params: { language: idioma.value } }, { replace: true });
    return;
  }

  // Sessão que caiu no painel (token vencido, cadastro desativado): a API mandou
  // o motivo, e ele aparece aqui.
  const aviso = store.consumirAviso();
  if (aviso) mensagem(aviso);

  if (route.query["recuperar-senha"]) mostrarEsqueci.value = true;
});
</script>

<template>
  <NuxtLayout name="afiliado">
    <AfiliadoLogin @esqueci="abrirEsqueci" @mensagem="mensagem" />
    <ModalForgotPassword
      :showModalPwd="mostrarEsqueci"
      :emailUser="emailEsqueci"
      @showModalForgotPassword="(valor: boolean) => (mostrarEsqueci = valor)"
      @showModalMessages="showModalMessages"
    />
    <ModalMessages :options="opcoesModal" @showModalMessages="showModalMessages" />
  </NuxtLayout>
</template>
